import React from "react";
import VariantRowMobile from "./VariantRowMobile";

/**
 *
 * @param variants
 * @param tableRef
 * @param windowWidth
 * @param variantAccessoriesOpen
 * @param {boolean} showQuantityCol
 * @param {boolean} showPrices
 * @param {function} getTableHeaders
 * @returns {JSX.Element}
 * @constructor
 */
const VariantTableMobile = ({variants, tableRef, windowWidth, variantAccessoriesOpen, showQuantityCol, showPrices, showAccessoriesCol, getTableHeaders}) => {
    return (
        <table className='variant-table__table variant-table__table--mobile' cellSpacing={0}>
            <tbody>
                {variants.map(variant => (
                    <VariantRowMobile {...{
                        variant,
                        tableRef,
                        showQuantityCol,
                        showAccessoriesCol,
                        showPrices,
                        windowWidth,
                        variantAccessoriesOpen,
                        tableHeaders: getTableHeaders(true)
                    }} key={variant.id}/>
                ))}
            </tbody>
        </table>
    );
}


export default VariantTableMobile;